module.exports = __webpack_public_path__ + "static/img/005.1bc1dbb2.png";